module.exports = __webpack_public_path__ + "media/PrinterPromotion.779c7252.mp4";